export default __webpack_public_path__ + "static/media/190629_190332_IMG_3809.db24f86c.jpg";